import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form';
import { Radio } from 'antd';
import InputField from '../../../../helpers/Fields/InputField';
import { required } from 'redux-form-validators';
import { createQuiz, addQuestionQiuz, createPresentation, addSlide, updateQuestionStatus, addSlides } from '../../actions';
import {toastr} from 'react-redux-toastr'
import SelectFieldPresentation from './SelectField';
import './style.scss';
import SelectFieldFolder from './SelectFieldFolder';

class FormContent extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      type: 'create',
      statusQuestion: 3,
    }
  }
  

  submit = async (values) => {
    try {
      const {formatMessage} = this.context;
      const { handleClose, selectedQuestionIds } = this.props;

      if(!selectedQuestionIds || !Array.isArray(selectedQuestionIds) || !selectedQuestionIds.length) {
        return;
      }
      const { type, statusQuestion } = this.state;
  
      if(type == 'create') {
        const presentation = await createPresentation({name: values.name, folder_id: values.folder_id});
        console.log("FormContent -> submit -> presentation", presentation)
        
        console.log("FormContent -> submit -> selectedQuestionIds", selectedQuestionIds)
        await addSlides({
          pr_id: presentation.id,
          type: 'question',
          // src: id,
          order_x: -1,
          ids: selectedQuestionIds,
        });
        toastr.success(formatMessage('msgNotificationPres'), formatMessage('msgNotificationPresentationCreated'))
      } else {
        addSlides({
          pr_id: values.pr_id,
          type: 'question',
          // src: id,
          order_x: -1,
          ids: selectedQuestionIds,
        });
        // selectedQuestionIds.forEach(id => {
        //   addSlide({
        //     pr_id: values.pr_id,
        //     type: 'question',
        //     src: id,
        //     order_x: -1,
        //   });
        // })

        toastr.success(formatMessage('msgNotificationPres'), formatMessage('msgNotificationPresentationUpdate'))
      }
      

      await updateQuestionStatus({data: JSON.stringify({selectedQuestionIds , statusQuestion}) })
      this.props.checkAndUploadQuestions();
      this.props.checkAndUploadGeneralStatistic(true);
      handleClose();
     
    } catch (error) {
    console.log("FormContent -> submit -> error", error)
      
    }
  }

  render() {
    const {formatMessage} = this.context;
    const { handleSubmit, handleClose, selectedQuestionIds } = this.props;
    const { type, statusQuestion } = this.state;
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };

    return (
      <form className="create-dialog-form form-quiz-create" onSubmit={handleSubmit(this.submit)}>
        <div className="row">
          {!selectedQuestionIds || !Array.isArray(selectedQuestionIds) || !selectedQuestionIds.length ? <div style={{color: 'red', textAlign: 'center'}}>{formatMessage('errrMessageNotSelectedQuestionAddPresentation')}</div> : null}
        <Radio.Group onChange={(e) => {
          this.setState({ type: e.target.value });
        }} value={this.state.type}>
          <Radio style={radioStyle} value={'create'}>
            {formatMessage('optionTitleCerateNewPresentation')}
          </Radio>
          <div style={{marginLeft: 24}}>
            <Field 
              name='folder_id'
              component={SelectFieldFolder}
              validate={type == 'update' ? [] : [required()]}
              disabled={type == 'update'}
            />
            <Field 
              name='name'
              label={formatMessage('labelInputNameFolder')}
              component={InputField}
              validate={type == 'update' ? [] : [required()]}
              disabled={type == 'update'}
            />
            
          </div>
          <Radio style={radioStyle} value={'update'}>
            {formatMessage('optionTitleAddToExistinqPresentation')}
          </Radio>
          <div style={{marginLeft: 24}}>
            <Field 
              name='pr_id'
              component={SelectFieldPresentation}
              validate={type == 'create' ? [] : [required()]}
              disabled={type == 'create'}
            />
          </div>
          
        </Radio.Group>
        </div>
        <div className="radio-button-grout-status">
            <label>
                <input type="radio" onChange={() => {this.setState({statusQuestion: 3})}} checked={statusQuestion == 3}/>
                <div style={{marginLeft: 7}} className="item used">Used</div>
            </label>
            <label>
                <input type="radio" onChange={() => {this.setState({statusQuestion: 1})}} checked={statusQuestion == 1}/>
                <div style={{marginLeft: 7}} className="item read">Ready to use</div>
            </label>
            <label>
                <input type="radio"onChange={() => {this.setState({statusQuestion: 2})}} checked={statusQuestion == 2}/>
                <div style={{marginLeft: 7}} className="item unused">Unused</div>
            </label>
        </div>
        <div className="create-dialog-form__group flex" style={{marginTop: 10}}>
          <button className="btn btn-warning" type="button" onClick={() => {
            handleClose();
          }}>{formatMessage('btnModalCancel')}</button>
          <button className="btn btn-primary" type="submit">{formatMessage('btnModalCreatePresentation')}</button>
        </div>
      </form>
    );
  }
}

FormContent = reduxForm({
  form: 'form_presentation_add',
  enableReinitialize: true,
})(FormContent);

export default FormContent;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmPresentation/components/FormContent/index.js